import "./loader.css";

const Loader = () => {
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 7, 52, 0.2)",
        zIndex: "999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className={"spinner"}></div>
    </div>
  );
};

export default Loader;
